import React from 'react';
import { cn } from '../lib/utils';

type AppButtonVariant = 'primary' | 'secondary';

interface AppButtonProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  variant?: AppButtonVariant;
}

const VARIANT_STYLES: Record<AppButtonVariant, string> = {
  primary: 'bg-primary-brown text-white hover:bg-primary-brown shadow-lg shadow-highlight-dark/30',
  secondary: 'bg-white border border-gray-200 text-text-secondary hover:bg-gray-50',
};

export default function AppButton({
  variant = 'primary',
  className,
  type = 'button',
  ...props
}: AppButtonProps) {
  return (
    <button
      type={type}
      className={cn(
        'w-full rounded-xl font-bold transition-colors disabled:opacity-50 disabled:cursor-not-allowed flex justify-center items-center',
        VARIANT_STYLES[variant],
        className,
      )}
      {...props}
    />
  );
}